import { useEffect, useState } from "react";

// Listen for the tutorial engine's display-only demo instructions
// (`cortex:tutorial-demo`). A page passes the set of demo keys it can show;
// the hook returns the currently-requested key (or null) so the page can open
// the matching modal in demo mode — for DISPLAY only, never submitting.
//
//   const demo = useTutorialDemo(["add-member", "new-org"]);
//   {demo === "add-member" && <AddMemberModal tutorialDemo .../>}
//
// The engine sends { open: "<key>" } on step enter and { close: true } on
// leave / tour end, and also clears before each open so modals never stack.
export function useTutorialDemo(keys) {
  const [active, setActive] = useState(null);
  useEffect(() => {
    const set = new Set(keys);
    const onDemo = (e) => {
      const d = e.detail || {};
      if (d.close) { setActive(null); return; }
      if (d.open && set.has(d.open)) setActive(d.open);
    };
    window.addEventListener("cortex:tutorial-demo", onDemo);
    return () => window.removeEventListener("cortex:tutorial-demo", onDemo);
    // keys is a stable literal at call sites; stringify to avoid re-subscribing
    // on every render without demanding useMemo at every caller.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Array.isArray(keys) ? keys.join(",") : String(keys)]);
  return active;
}
